import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconDrag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.04545 4.09091C6.17513 4.09091 7.09091 3.17513 7.09091 2.04545C7.09091 0.915781 6.17513 0 5.04545 0C3.91578 0 3 0.915781 3 2.04545C3 3.17513 3.91578 4.09091 5.04545 4.09091ZM5.04545 9.54545C6.17513 9.54545 7.09091 8.62967 7.09091 7.5C7.09091 6.37033 6.17513 5.45455 5.04545 5.45455C3.91578 5.45455 3 6.37033 3 7.5C3 8.62967 3.91578 9.54545 5.04545 9.54545ZM7.09091 12.9545C7.09091 14.0842 6.17513 15 5.04545 15C3.91578 15 3 14.0842 3 12.9545C3 11.8249 3.91578 10.9091 5.04545 10.9091C6.17513 10.9091 7.09091 11.8249 7.09091 12.9545ZM10.5 4.09091C11.6297 4.09091 12.5455 3.17513 12.5455 2.04545C12.5455 0.915781 11.6297 0 10.5 0C9.37033 0 8.45455 0.915781 8.45455 2.04545C8.45455 3.17513 9.37033 4.09091 10.5 4.09091ZM12.5455 7.5C12.5455 8.62967 11.6297 9.54545 10.5 9.54545C9.37033 9.54545 8.45455 8.62967 8.45455 7.5C8.45455 6.37033 9.37033 5.45455 10.5 5.45455C11.6297 5.45455 12.5455 6.37033 12.5455 7.5ZM10.5 15C11.6297 15 12.5455 14.0842 12.5455 12.9545C12.5455 11.8249 11.6297 10.9091 10.5 10.9091C9.37033 10.9091 8.45455 11.8249 8.45455 12.9545C8.45455 14.0842 9.37033 15 10.5 15Z",
		fill: "currentColor"
	})
});
export default SvgIconDrag;
